import React from "react";
import { Link } from "react-router-dom";

export const BrandLogo = ({ size = 48, withText = true, className = "" }) => (
  <Link
    to="/"
    data-testid="brand-logo"
    className={`flex items-center gap-3 ${className}`}
    aria-label="La Maison de ta Sorcière Préférée — Accueil"
  >
    <img
      src="/brand-logo.png"
      alt="La Maison de ta Sorcière Préférée"
      style={{ width: size, height: size }}
      className="rounded-full object-contain"
    />
    {withText && (
      <span className="hidden sm:flex flex-col leading-tight">
        <span className="font-serif text-[15px] font-semibold tracking-wide text-[#5A3A4B]">
          La Maison de ta
        </span>
        <span className="font-serif text-[15px] font-semibold tracking-wide text-[#5A3A4B]">
          Sorcière Préférée
        </span>
      </span>
    )}
  </Link>
);

export default BrandLogo;
